<template>
  <div class="app-main-inner">
    <div class="app-main-page">
      <span style="position: absolute; right: 10px; margin-top: 5px;">
        <el-link :type="lbAccountType" @click="selectAccountSetHandler">{{ lbAccount }}</el-link>
      </span>
      <accounting-document-btn-group :type="type" />
      <accounting-document-form ref="documentForm" :account-set="accountSet" :type="type" :voucher-index="voucherIndex" :voucher-list="voucherList" @cancel="cancelCallBack" />
      <!-- 选择账套 -->
      <account-set-popup
        ref="refAccountSetPopup"
        :visible.sync="accountSetPopup.visible"
        :mode="accountSetPopup.mode"
        :load-mapping-departments-flag="false"
        :load-mapping-staffs-flag="false"
        :load-accounting-documents-rule-flag="false"
        :load-current-rates-flag="true"
        @select="data=>accountSet=data"
        @cancel="()=>accountSetPopup.visible=false"
      />
    </div>
  </div>
</template>

<script>
import AccountingDocumentBtnGroup from './components/AccountingDocumentBtnGroup'
import AccountingDocumentForm from './components/AccountingDocumentForm'
import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'

export default {
  name: 'AccountingDocument',
  components: { AccountingDocumentForm, AccountingDocumentBtnGroup, AccountSetPopup },
  props: {
    type: {
      type: String,
      default: 'add'
    },
    voucherList: {
      type: Array,
      default: null
    },
    voucherIndex: {
      type: Number,
      default: null
    },
    currentAccountSet: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      accountSetPopup: { visible: false, mode: 'office' },
      accountSet: null // 当前账套
    }
  },
  computed: {
    lbAccount() {
      console.log('lbAccount', this.accountSet)
      return this.accountSet === null ? this.$t('CargoMsg.Cargo_PleaseSelectSob') : (this.$t('CargoMsg.Cargo_SetsOfBooksP') + this.accountSet.name)
    },
    lbAccountType() {
      return this.accountSet === null ? 'danger' : 'primary'
    }
  },
  async mounted() {
    const allowFinanceOperation = await BSWarningUtil.checkFinanceExpire(this.$route, this.$router)
    if (!allowFinanceOperation) {
      return
    }
    if (this.currentAccountSet) {
      this.accountSet = this.currentAccountSet
    } else {
      this.selectAccountSetHandler()
    }
  },
  methods: {
    // 选择账套
    selectAccountSetHandler() {
      this.accountSetPopup.visible = true
    },
    cancelCallBack() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
